export const NEW_ENDPOINTS = Object.freeze({
	AUTH: {
		LOGIN: '/admin/login',
	},
	ADMIN: {
		TRANSACTIONS: {
			LIST: '/admin/transaction',
			INFO: '/admin/transaction_info',
			LEDGER: '/admin/ledger',
		},
		REPORTS: {
			BALANCES: '/admin/balances_report',
			SEPA: '/admin/sepa_report',
			FEES: '/admin/fees_report',
		},
		CLOSE_DAY: {
			SUBMIT: '/admin/close_day',
			GET_HISTORY: '/admin/close_days',
			DELETE: '/admin/close_day_delete',
		},
		TARIFFS: '/admin/tariffs',
		USER: {
			CREATE: '/admin/user_create',
			CORPORATION: {
				CREATE: '/admin/corporate_create',
				GENERATE_DOC: '/admin/corporate_pdf_generate',
				CONFIRM: '/admin/corporate_confirm',
				SIGN: '/admin/corporate_pdf_sign',
				SIGNED_DOC: '/admin/corporate_pdf_signed',
				SIGNED: '/admin/corporate_pdf_signed_exists',
				AML_UPLOAD: '/admin/corporate_aml_upload',
				AML_EXISTS: '/admin/corporate_aml_exists',
				AML_DOWNLOAD: '/admin/corporate_aml_download',
				ADD_MEMBER: '/admin/corporate_member_add',
				DELETE_MEMBER: '/admin/corporate_member_delete',
				INFO: '/admin/corporate_info',
				ADD_INFO: '/admin/corporate_info_add',
				UPLOAD_FILE: '/admin/corporate_file_upload',
				DOWNLOAD_FILE: '/admin/corporate_file_download',
				FILE_LIST: '/admin/corporate_file_list',
			},
			UPDATE: '/admin/user_edit',
			GET_LIST: '/admin/users',
			GET_BALANCES: '/admin/user_balances',
			GET_SUMSUB_LINK: '/admin/sumsub_link',
			SET_OVERDRAFT: '/admin/user/overdraft/set',
			BLOCK: {
				LOGIN: '/admin/user/block/login',
				ORDER: '/admin/user/block/order',
			}
		},
		ORDER: {
			CREATE: '/admin/order',
			UPDATE: '/admin/order_edit',
			DELETE: '/admin/order_delete',
			GET_FEE_BALANCES: '/admin/fee_balances'
		},
		SCORE: {
			GET_HISTORY: '/admin/sumsub_score_history',
			GET_ALL: '/admin/sumsub_score_tags',
			MODIFY: '/admin/sumsub_score_modify'
		},
		FEE: {
			LIST: '/admin/fee/list',
			DELETE: '/admin/fee/delete',
			CREATE: '/admin/fee/create',
			DEDUCT: '/admin/transaction/manual-fee/create'
		}
	},
});
